import { render, staticRenderFns } from "./image-elem.vue?vue&type=template&id=7380044f&scoped=true"
import script from "./image-elem.vue?vue&type=script&lang=js"
export * from "./image-elem.vue?vue&type=script&lang=js"
import style0 from "./image-elem.vue?vue&type=style&index=0&id=7380044f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7380044f",
  null
  
)

export default component.exports